/* mo:mo Skills — Filter-Tabs + inkrementelles „Alle anzeigen" (Batch = konfigurierte Anzahl) */
class MomoSkills extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.momo-skills__tab'));
    this.cards = Array.from(this.querySelectorAll('.momo-skills__card'));
    this.moreBtn = this.querySelector('.momo-skills__more-btn');
    this.desktopVisible = parseInt(this.dataset.desktopVisible, 10) || 9;
    this.mobileVisible = parseInt(this.dataset.mobileVisible, 10) || 4;
    this.activeCat = 'all';

    this.mq = window.matchMedia('(min-width: 990px)');
    this.batch = this.currentBatch();
    this.shown = this.batch;

    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab)));
    if (this.moreBtn) {
      this.moreBtn.addEventListener('click', () => {
        this.shown += this.batch;       // pro Klick: konfigurierte Anzahl mehr
        this.apply();
      });
    }
    // Breakpoint-Wechsel: Batch & Collapse zurücksetzen
    this.mq.addEventListener('change', () => {
      this.batch = this.currentBatch();
      this.shown = this.batch;
      this.apply();
    });

    this.classList.add('is-enhanced');
    this.apply();
  }

  currentBatch() {
    return this.mq.matches ? this.desktopVisible : this.mobileVisible;
  }

  selectTab(tab) {
    const cat = tab.dataset.cat || 'all';
    this.tabs.forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.activeCat = cat;
    this.shown = this.batch;            // Filterwechsel setzt Collapse zurück
    this.apply();
  }

  apply() {
    let visibleIndex = 0;
    this.cards.forEach((card) => {
      const eligible = this.activeCat === 'all' || card.dataset.cat === this.activeCat;
      card.classList.toggle('is-hidden', !eligible);   // Kategorie-Filter
      if (eligible) {
        const clipped = visibleIndex >= this.shown;    // über aktuellem Limit?
        card.classList.toggle('is-clipped', clipped);
        visibleIndex += 1;
      } else {
        card.classList.remove('is-clipped');
      }
    });
    // Verlauf + Button nur, wenn es noch versteckte (passende) Cards gibt
    this.classList.toggle('can-expand', visibleIndex > this.shown);
  }
}

if (!customElements.get('momo-skills')) {
  customElements.define('momo-skills', MomoSkills);
}
